// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/@angular/material/prebuilt-themes/deeppurple-amber.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.date-select {
  position: relative;
  padding: var(--small-spacing) var(--large-spacing);
  width: 100%;
  min-width: 365px;
}
button.date-select .range-label {
  width: 100%;
}
button.date-select .hidden-date-input {
  opacity: 0;
  top: 30px;
  left: 40px;
  width: 100px;
  pointer-events: none;
  position: absolute;
}
button.date-select .ngx-dates-picker-input {
  position: absolute;
  opacity: 0;
  left: 0;
  top: 0;
  width: 100% !important;
  box-sizing: border-box;
  cursor: pointer;
}
button.date-select .date {
  padding: 0px 5px 0px 5px;
}
button.date-select .date-button {
  font-size: 32px;
  cursor: pointer;
}
@media (hover: hover) {
  button.date-select .date-button:hover {
    color: var(--motes-gold);
  }
}
button.date-select .date-button:not(:active) {
  animation-name: clickAnim;
  animation-duration: 1.2s;
}
@keyframes clickAnim {
  1% {
    color: var(--motes-gold);
  }
}
button.date-select .ngx-dates-picker-calendar-container {
  color: rgb(43, 43, 43);
  left: -50% !important;
  z-index: 2;
  width: auto;
  box-sizing: border-box;
  padding-right: 30px;
  width: 320px;
}
button.date-select .time-row {
  display: inline-block;
}
button.date-select .calendar-icon {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
}

.mat-calendar-body-selected {
  background-color: var(--motes-highlight-color);
}

.mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover > .mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),
.cdk-keyboard-focused .mat-calendar-body-active > .mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),
.cdk-program-focused .mat-calendar-body-active > .mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical) {
  background-color: var(--motes-highlight-color);
}

.cdk-overlay-container {
  z-index: 20;
}

input[type=time]::-webkit-clear-button {
  display: none;
}

[type=time]::-webkit-inner-spin-button {
  display: none;
}

[type=time]::-webkit-calendar-picker-indicator {
  opacity: 0;
  display: none;
}

.date-picker-container {
  position: relative;
  display: inline-block;
}

.predefined-ranges {
  position: fixed;
  opacity: 1;
  z-index: 21;
  border-radius: 4px 0px 0px 4px;
  background-color: var(--motes-white);
  color: black;
  font-size: 13px;
  padding: 16px;
  box-sizing: border-box;
  font-weight: bold;
  border-right: 1px solid var(--motes-dark-gray);
  width: 180px;
}
.predefined-ranges .predefined-option {
  padding: var(--mini-spacing) var(--small-spacing);
  margin-bottom: var(--mini-spacing);
  border-radius: 16px;
  cursor: pointer;
}
.predefined-ranges .selected {
  background-color: var(--motes-light-blue);
  color: white;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/time-range-picker/time-range-picker.component.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,kDAAA;EACA,WAAA;EACA,gBAAA;AAAJ;AAEI;EACI,WAAA;AAAR;AAGI;EACI,UAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AADR;AAII;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;AAFR;AAKI;EACI,wBAAA;AAHR;AAMI;EACI,eAAA;EACA,eAAA;AAJR;AAQI;EACI;IACI,wBAAA;EANV;AACF;AAUI;EACI,yBAAA;EACA,wBAAA;AARR;AAWK;EACI;IAAK,wBAAA;EARZ;AACF;AAUI;EACI,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AARR;AAWI;EACI,qBAAA;AATR;AAYI;EACI,YAAA;EACA,aAAA;EACA,yBAAA;AAVR;;AAcA;EACI,8CAAA;AAXJ;;AAcA;;;EAGI,8CAAA;AAXJ;;AAcA;EACI,WAAA;AAXJ;;AAcA;EACI,aAAA;AAXJ;;AAcA;EACI,aAAA;AAXJ;;AAcA;EACI,UAAA;EACA,aAAA;AAXJ;;AAcA;EACI,kBAAA;EACA,qBAAA;AAXJ;;AAcA;EACI,eAAA;EACA,UAAA;EACA,WAAA;EACA,8BAAA;EACA,oCAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,8CAAA;EACA,YAAA;AAXJ;AAaI;EACI,iDAAA;EACA,kCAAA;EACA,mBAAA;EACA,eAAA;AAXR;AAcI;EACI,yCAAA;EACA,YAAA;AAZR","sourcesContent":["@import '@angular/material/prebuilt-themes/deeppurple-amber.css';\n\nbutton.date-select {\n    position: relative;\n    padding: var(--small-spacing) var(--large-spacing);\n    width: 100%;\n    min-width: 365px;\n\n    .range-label {\n        width: 100%;\n    }\n\n    .hidden-date-input {\n        opacity: 0;\n        top: 30px;\n        left: 40px;\n        width: 100px;\n        pointer-events: none;\n        position: absolute;\n    }\n\n    .ngx-dates-picker-input {\n        position: absolute;\n        opacity: 0;\n        left: 0;\n        top: 0;\n        width: 100% !important;\n        box-sizing: border-box;\n        cursor:pointer;\n    }\n\n    .date {\n        padding: 0px 5px 0px 5px\n    }\n\n    .date-button {\n        font-size: 32px;\n        cursor: pointer;\n    }\n\n    // Only show hover on desktop\n    @media(hover: hover) {\n        .date-button:hover {\n            color: var(--motes-gold);\n        }\n    }\n\n    // Enylate hover / click css\n    .date-button:not(:active) {\n        animation-name: clickAnim;\n        animation-duration: 1.2s;\n     }\n\n     @keyframes clickAnim {\n         1% { color: var(--motes-gold) }\n     }\n\n    .ngx-dates-picker-calendar-container {\n        color:rgb(43, 43, 43);\n        left: -50%!important;\n        z-index: 2;\n        width: auto;\n        box-sizing: border-box;\n        padding-right: 30px;\n        width: 320px;\n    }\n\n    .time-row {\n        display: inline-block;\n    }\n\n    .calendar-icon {\n        flex-grow: 1;\n        display: flex;\n        justify-content: flex-end;\n    }\n}\n\n.mat-calendar-body-selected {\n    background-color: var(--motes-highlight-color);\n}\n\n.mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),\n.cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),\n.cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical) {\n    background-color: var(--motes-highlight-color);\n}\n\n.cdk-overlay-container {\n    z-index: 20;\n}\n\ninput[type=\"time\"]::-webkit-clear-button {\n    display: none;\n}\n\n[type=\"time\"]::-webkit-inner-spin-button {\n    display: none;\n}\n\n[type=\"time\"]::-webkit-calendar-picker-indicator {\n    opacity: 0;\n    display: none;\n}\n\n.date-picker-container {\n    position: relative;\n    display: inline-block;\n}\n\n.predefined-ranges {\n    position: fixed;\n    opacity: 1;\n    z-index: 21; // Cover menu but not header\n    border-radius: 4px 0px 0px 4px;\n    background-color: var(--motes-white);\n    color: black;\n    font-size: 13px;\n    padding: 16px;\n    box-sizing: border-box;\n    font-weight: bold;\n    border-right: 1px solid var(--motes-dark-gray);\n    width: 180px;\n\n    .predefined-option {\n        padding: var(--mini-spacing) var(--small-spacing);\n        margin-bottom: var(--mini-spacing);\n        border-radius: 16px;\n        cursor: pointer;\n    }\n\n    .selected {\n        background-color: var(--motes-light-blue);\n        color: white;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
